import React from "react";
import styled, { css } from "styled-components";
import NationwideCoverage from "./Icons/NatiowideCoverage";
import CallTrackLink from "./CalltrackLink";
import ContactTelephoneWrapper from "./ContactTelephoneWrapper";

const AreasCoveredStyles = styled.div`
  ${({ ...props }) => css`
    background: ${props.theme.colors.lightPrimary};
    padding: 48px 24px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    overflow: hidden;

    div {
      z-index: 2;
    }

    p {
      margin-bottom: 24px;
      font-size: 1.75rem;
      line-height: 32px;
    }

    a {
      color: ${props.theme.colors.primary};
    }

    svg {
      position: absolute;
      top: 32px;
      right: -100px;
    }

    /* Mobile styles */
    @media (max-width: 767px) {
      svg {
        opacity: 0.5;
      }
    }

    /* Desktop styles */
    @media (min-width: ${props.theme.breakpoints.md}) {
      padding: 32px;

      p {
        font-size: 2.25rem;
        line-height: 48px;
      }

      svg {
        position: absolute;
        top: 32px;
        right: 32px;
      }
    }
  `}
`;

export const AreasCoveredBanner = () => {
  return (
    <AreasCoveredStyles>
      <div>
        <p>Nationwide coverage</p>
        <ContactTelephoneWrapper>
          <h3>
            Call now <CallTrackLink />
          </h3>
        </ContactTelephoneWrapper>
      </div>
      <NationwideCoverage />
    </AreasCoveredStyles>
  );
};
